import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import { ApiItemResponse, unwrapItem, withServerMessage } from './api/response';
import type { FocusAiCamera } from './nvrTemplateExport';

/**
 * 포커스AI 녹화기 원격 등록 — 통합서버에 SSH 로 붙어 녹화기 웹 API 로 [카메라 검색] → [검색 등록]
 * 을 한다. apply=false 는 녹화기를 바꾸지 않는 미리보기.
 */

export type NvrRegisterStatus = 'planned' | 'ok' | 'check' | 'skip' | 'fail';

export interface NvrRegisterItem {
  channel: number;
  ip: string;
  title: string;
  status: NvrRegisterStatus;
  reason?: string;
  main: boolean;
  sub: boolean;
}

export interface NvrRegisterResult {
  apply: boolean;
  channelCount: number;
  discovered: number;
  items: NvrRegisterItem[];
}

export interface NvrRegisterRequest {
  serverDeviceId: number;
  nvrDeviceId: number;
  nvrUser: string;
  nvrPassword: string;
  apply: boolean;
  cameras: FocusAiCamera[];
}

export class NvrRegisterService {
  static async register(projectId: number, req: NvrRegisterRequest): Promise<NvrRegisterResult> {
    const response = await withServerMessage(() =>
      apiClient.post<ApiItemResponse<NvrRegisterResult>>(
        API_ENDPOINTS.SITE_MANAGEMENT.NVR_REGISTER(projectId),
        req,
      ),
    );
    return unwrapItem(response, 'NVR 원격 등록 실패');
  }
}
